import React from "react";
import Hero from "../components/Hero";
import Testimonies from "../components/PageTestimony";

export default function TestimonyPage() {
  return (
    <div className="bg-[#1A1F2B] text-white w-full min-h-screen flex flex-col items-center">

      {/* Section 1: Hero */}
      {/* <section className="w-full bg-[#1A1F2B] px-6 py-16 text-center mt-8" data-aos="fade-up">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-[#D9A05B]">
          Testimonies of Faith
        </h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto text-[#F5E9D8]">
          Real stories of transformation, healing, and the undeniable power of Jesus Christ working in the lives of our church members.
        </p>
      </section> */}
      <Hero
        title="Hear Their Stories"
        description="Discover inspiring testimonies from members of Moriah Church who have experienced God's transformative power in their lives through faith, prayer, and community."
      />

      {/* Section 2: Testimony Cards */}
      {/* <section className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-6 py-14 rounded-t-3xl" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-center mb-10">Powerful Testimonies</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-6 border-l-4 border-[#D9A05B]">
            <h3 className="text-2xl font-bold mb-2">Rita S. – Delhi</h3>
            <p className="text-lg leading-relaxed">
              “Moriah Church has transformed my life. Through prayers, counseling,
              and God’s Word, I found peace, clarity, and a renewed purpose.
              Today, I walk confidently in faith.”
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-6 border-l-4 border-[#D9A05B]">
            <h3 className="text-2xl font-bold mb-2">Ajay K. – Naraina</h3>
            <p className="text-lg leading-relaxed">
              “The prayer meetings and Bible teachings strengthened my relationship
              with God. Many prayers were answered, and God opened new doors in my career.”
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-6 border-l-4 border-[#D9A05B]">
            <h3 className="text-2xl font-bold mb-2">Neha M. – New Delhi</h3>
            <p className="text-lg leading-relaxed">
              “I came broken and emotionally exhausted, but God healed me completely.
              The love and prayers of the church family restored my strength and hope.”
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-6 border-l-4 border-[#D9A05B]">
            <h3 className="text-2xl font-bold mb-2">Samuel R. – Gurugram</h3>
            <p className="text-lg leading-relaxed">
              “God brought unity, financial breakthrough, and peace into my family.
              Moriah Church has truly been a blessing and a spiritual home for us.”
            </p>
          </div>
        </div>
      </section> */}
      <Testimonies/>

      {/* Section 3: Impact of Testimonies */}
      <section className="w-full bg-[#1A1F2B] px-6 py-14" data-aos="fade-up">
        <div className="max-w-5xl mx-auto space-y-6 text-center">
          <h2 className="text-3xl font-bold text-[#D9A05B]">
            Why Testimonies Matter
          </h2>
          <p className="text-lg leading-relaxed text-[#F5E9D8] max-w-4xl mx-auto">
            Testimonies are living proof of God’s faithfulness. They strengthen faith,
            inspire hope, and remind us that God is still working miracles today.
            Every story shared becomes a source of encouragement for someone else.
          </p>
          <p className="text-lg leading-relaxed text-[#F5E9D8] max-w-4xl mx-auto">
            At Moriah Church, we celebrate what God has done and trust Him for
            what He will continue to do in the lives of His people.
          </p>
        </div>
      </section>

      {/* Section 4: Written Testimony Submission CTA */}
      <section className="w-full bg-[#D2CBC3] text-[#1A1F2B] px-6 py-14 rounded-t-3xl" data-aos="fade-up">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h2 className="text-3xl font-bold">Share Your Testimony</h2>
          <p className="text-lg leading-relaxed">
            Has God touched your life through Moriah Church?
            Your testimony can inspire others and strengthen their faith.
            We encourage you to share how God has worked in your life.
          </p>

          <button className="px-8 py-3 bg-[#D9A05B] text-white font-bold rounded-xl shadow-md hover:bg-[#C9A86A] transition-all duration-300">
            Send Your Testimony
          </button>
        </div>
      </section>

      {/* Section 5: Contact Information */}
      <section className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-6 py-14" data-aos="fade-up">
        <div className="max-w-5xl mx-auto text-center space-y-6">
          <h2 className="text-3xl font-bold mb-4">Need Prayer or Support?</h2>
          <p className="text-lg max-w-3xl mx-auto leading-relaxed">
            Our prayer team is always ready to stand with you.
            If you need prayer, counseling, or spiritual guidance,
            please reach out to us.
          </p>

          <p className="text-lg font-semibold">📞 8800229968</p>
          <p className="text-lg font-semibold">✉️ moriahchurchnaraina@gmail.com</p>
        </div>
      </section>
    </div>
  );
}
